const { useEffect, useState } = wp.element;

import Category from './steps/Category'
import Service from './steps/Service'
import AdditionalServices from './steps/AdditionalServices'
import Time from './steps/Time'
import Employee from './steps/Employee'

const Component = ({ 
    bookingData, 
    department, 
    bookingType,
    category, 
    setCategory,
    service, 
    setService,
    hasAdditionalServices,
    setHasAdditionalServices,
    additionalServices,
    setAdditionalServices,
    additionalServicesOptions,
    addOrRemoveAdditionalService,
    handleGetAvailableDates,
    availableDates,
    date, 
    setDate, 
    timeslot, 
    setTimeslot,
    loadingAvailableTimeslots,
    availableTimeslots,
    employee, 
    setEmployee, 
}) => {
    useEffect(() => {
        // Reset later fields
        setCategory(null)
        setService(null)
        setHasAdditionalServices(null)
        setAdditionalServices([])
        setDate(null)
        setTimeslot(null)
        setEmployee(null)
        
        if (bookingType) {
            // scroll down to next section
            const nextSection = document.getElementById('section-category')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [bookingType])

    useEffect(() => {
        // Reset later fields
        setService(null)
        setHasAdditionalServices(null)
        setAdditionalServices([])
        setDate(null)
        setTimeslot(null)
        setEmployee(null)

        if (category) {
            // scroll down to next section
            const nextSection = document.getElementById('section-service')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [category])

    useEffect(() => {
        // Reset later fields
        setHasAdditionalServices(null)
        setAdditionalServices([])
        setDate(null)
        setTimeslot(null)
        setEmployee(null)

        if (service) {
            // scroll down to next section
            const nextSection = document.getElementById('section-additional-services')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [service])

    useEffect(() => {
        // Reset later fields
        setAdditionalServices([])
        setDate(null)
        setTimeslot(null)
        setEmployee(null)

        if (hasAdditionalServices === false) {
            // scroll down to next section
            const nextSection = document.getElementById('section-date-time')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
        
        if (hasAdditionalServices === true) {
            // scroll down to next section
            const nextSection = document.getElementById('section-additional-services')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [hasAdditionalServices])
    
    useEffect(() => {
        // Reset later fields
        setEmployee(null)
        
        if (timeslot) {
            // scroll down to next section
            const nextSection = document.getElementById('section-employee')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [timeslot])

    useEffect(() => {
        // Reset later fields
        
        // Show status bar
    }, [employee])

    return (
        <>
            {
                /* ------------------------------ */
                /*  Category                      */
                /* ------------------------------ */
                bookingData &&
                bookingType &&
                department &&
                department.ref !== 'dale' &&
                <Category
                    bookingData={bookingData}
                    category={category}
                    setCategory={setCategory}
                />
            }

            {
                /* ------------------------------ */
                /*  Service                       */
                /* ------------------------------ */
                bookingData &&
                department &&
                bookingType &&
                category &&
                <Service
                    bookingData={bookingData}
                    category={category}
                    service={service}
                    setService={setService}
                />
            }

            {
                /* ------------------------------ */
                /*  Additional services           */
                /* ------------------------------ */
                bookingData &&
                department &&
                bookingType &&
                category &&
                service &&
                <AdditionalServices
                    hasAdditionalServices={hasAdditionalServices}
                    setHasAdditionalServices={setHasAdditionalServices} 
                    additionalServicesOptions={additionalServicesOptions}
                    additionalServices={additionalServices}
                    addOrRemoveAdditionalService={addOrRemoveAdditionalService}
                />
            }

            {
                /* ------------------------------ */
                /*  Date and time                 */
                /* ------------------------------ */
                bookingData &&
                department &&
                bookingType &&
                category &&
                service &&
                <Time
                    date={date}
                    setDate={setDate}
                    timeslot={timeslot}
                    setTimeslot={setTimeslot}
                    loadingAvailableTimeslots={loadingAvailableTimeslots}
                    availableTimeslots={availableTimeslots}
                    handleGetAvailableDates={handleGetAvailableDates}
                    availableDates={availableDates}
                />
            }

            {
                /* ------------------------------ */
                /*  Employee                      */
                /* ------------------------------ */
                bookingData &&
                department &&
                bookingType &&
                category &&
                service &&
                date &&
                timeslot &&
                <Employee
                    loadingEmployees={false}
                    employees={timeslot?.items?.map(item => item.resource)}
                    employee={employee}
                    setEmployee={setEmployee}
                    bookingData={bookingData}
                />
            }
        </>
    )
}

export default Component;